import React from "react";
import { formatAppDate } from "../../helpers/date-formatter";

function UserOfferRedeemSummaryTable({ redeems }) {
  return (
    <>
      <table className="w-full min-w-[640px] table-auto">
        <thead>
          <tr>
            {[
              "sn",
              "amount (€)",
              "code",
              "redeem date",
              "status",
              "approved date",
              "expiry date",
            ].map((el, id) => (
              <th
                key={el}
                className={`border-y bg-slate-100 border-slate-200 py-3 px-5 ${
                  id == 0 ? "text-left" : "text-center"
                }`}
              >
                <span className="text-[11px] font-bold uppercase text-slate-400">
                  {el}
                </span>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {redeems.map((redeem, index) => {
            const {
              id,
              amount,
              approved,
              approvedDate,
              code,
              redeemedOn,
              expiryDate,
            } = redeem;

            return (
              <tr key={id}>
                <td className="py-3 px-5 border-b border-slate-200 w-4">
                  <div className="flex flex-col gap-2">
                    <span className="text-left text-xs font-semibold text-slate-600">
                      {index + 1}
                    </span>
                  </div>
                </td>
                <td className="text-center py-3 px-5 border-b border-slate-200 w-12">
                  <span className="text-xs font-semibold text-slate-600">
                    €{amount}
                  </span>
                </td>
                <td className="text-center py-3 px-5 border-b border-slate-200 w-16">
                  <span className="text-xs font-semibold text-slate-600">
                    {code}
                  </span>
                </td>
                <td className="text-center py-3 px-5 border-b border-slate-200 w-32">
                  <span className="text-xs font-semibold text-slate-600">
                    {formatAppDate(redeemedOn)}
                  </span>
                </td>
                <td className="text-center py-3 px-5 border-b border-slate-200 w-32">
                  <span
                    className={`text-xs font-semibold rounded-md py-1 px-3 ${
                      approved
                        ? "text-blue-500 bg-blue-100"
                        : "text-amber-500 bg-amber-100"
                    }`}
                  >
                    {approved ? "Approved" : "Pending"}
                  </span>
                </td>
                <td className="text-center py-3 px-5 border-b border-slate-200 w-32">
                  <span className="text-xs font-semibold text-slate-600">
                    {approvedDate != null ? formatAppDate(approvedDate) : "-"}
                  </span>
                </td>
                <td className="text-center py-3 px-5 border-b border-slate-200 w-32">
                  <span className="text-xs font-semibold text-slate-600">
                    {formatAppDate(expiryDate)}
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
}

export default UserOfferRedeemSummaryTable;
